<template>
  <dx-tab-panel>
    <dx-item
      title="Orders"
      template="orders-tab"
    />
    <dx-item
      title="Profiles"
      template="profiles-tab"
    />
    <order-tab
      slot="orders-tab"
      :orderData="masterDetailData"
    />
    <profiles-tab
      slot="profiles-tab"
      :profileData="masterDetailData"
    />
  </dx-tab-panel>
</template>

<script>
  import {
    DxTabPanel,
    DxItem
  } from 'devextreme-vue/tab-panel'
  import OrderTab from '@/components/recherche/rechercheSearch/masterDetail/OrderTab.vue'
  import ProfilesTab from '@/components/recherche/rechercheSearch/masterDetail/ProfileTab.vue'

  export default {
    components: {
      DxTabPanel,
      DxItem,
      OrderTab,
      ProfilesTab
    },
    props: {
      masterDetailData: {
        type: Object,
        default: () => ({})
      },
      addressId: {
        type: Number
      }
    },
    data () {
      return {
      }
    }
  }
</script>
<style lang="scss">
.dx-datagrid-rowsview .dx-row > .dx-master-detail-cell{
  padding: 5px;
}
</style>
